import {
  type CalendarEventFormData,
  GROUP_KIND,
  GROUP_TYPE,
  type Group,
  type GroupSettingsData,
  type GroupShareOptions,
  MESSAGES_LIST_SORT_FIELD,
  MESSAGE_STATUS,
  type MassEventFormData,
  type Member,
  type MemberGroup,
  type MessageRecipientsInfoResponse,
  type MessageStatisticsData,
  type MessagesListRequestFiltersData,
  type NewUserForm,
  SORT_DIRECTION,
  USER_FORM_PROGRAM,
  USER_FORM_STATUS,
} from '@/types';
import {
  GROUPS_LIST_SORT_FIELD,
  type GroupListRequestFiltersData,
} from '@/types/requests/groupsListRequestFiltersData.type';

export const emptyGroupListRequestFilters: GroupListRequestFiltersData = {
  term: '',
  sortBy: GROUPS_LIST_SORT_FIELD.CREATED_DATE,
  sortOrder: SORT_DIRECTION.DESC,
};

export const emptyMessagesListRequestFilters: MessagesListRequestFiltersData = {
  term: '',
  sortBy: MESSAGES_LIST_SORT_FIELD.CREATED_DATE,
  sortOrder: SORT_DIRECTION.DESC,
  status: MESSAGE_STATUS.SENT,
};

export const emptyMember: Omit<Member, 'id'> = {
  firstName: '',
  middleName: '',
  lastName: '',
  phone: '',
  email: '',
  dob: null,
  isAdult: false,
};

export const emptyMemberGroup: MemberGroup = {
  id: '',
  name: '',
  deliveryMethods: [],
  isAdmin: false,
  isRemove: false,
};

export const emptyGroupInfo: Omit<Group, 'id'> = {
  name: '',
  description: '',
  keyword: '',
  type: GROUP_TYPE.PUBLIC,
  kind: GROUP_KIND.REGULAR,
  isActive: true,
  parent: null,
};

export const emptyGroupShareOptions: GroupShareOptions = {
  facebook: [],
  // TODO: Twitter/X is temporarily disabled. This code may be deleted later.
  // isTwitterConnected: false,
};

export const DEFAULT_RSS_FEED_POSTS_NUM = 10;

export const RSS_FEED_POSTS_OPTIONS = [1, 3, 5, 10, 20] as const;

export const emptyCalendarEvent: CalendarEventFormData = {
  title: '',
  description: '',
  locationId: null,
  liturgyId: null,
  eventChurchId: '',
  calendarId: '',
  start: { date: '', time: '' },
  end: null,
  isAllDay: false,
  isPerpetual: false,
  formAttachment: {
    filePath: null,
    removeCurrentFile: true,
  },
};

export const emptyGroupSettingsData: GroupSettingsData = {
  ...emptyGroupInfo,
  ...emptyGroupShareOptions,
  kind: GROUP_KIND.REGULAR,
  id: '',
  admins: [],
  adminMembersAccess: [],
  churchKeyword: '',
  publicInvitationUrlKey: '',
  isRssFeedEnabled: false,
  rssFeedPostsNum: DEFAULT_RSS_FEED_POSTS_NUM,
  rssFeedUrl: null,
  bulletin: false,
  isBulletinSmsEnabled: false,
  isUserMessagesAllowed: false,
};

export const emptyMassEvent: MassEventFormData = {
  description: '',
  locationId: null,
  liturgyId: null,
  languageId: null,
  eventChurchId: '',
  calendarId: '',
  start: { date: '', time: '' },
  end: null,
  isPerpetual: false,
  isAllDay: false,
};

export const emptyMessageStatisticsData: MessageStatisticsData = {
  clicks: 0,
  delivered: 0,
  failed: 0,
  opened: 0,
  sent: 0,
};

export const emptyMessageRecipientsInfoData: MessageRecipientsInfoResponse = {
  totalCount: 0,
  groups: [],
  members: [],
  communityLists: [],
  communityListCards: [],
  deliveryMethods: [],
};

export const emptyNewUserForm: NewUserForm = {
  responseEmail: '',
  status: USER_FORM_STATUS.DRAFT,
  program: USER_FORM_PROGRAM.FORMS,
  content: {
    title: '',
    description: '',
  },
};
